"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeNotification = exports.addNotification = void 0;
var initialState = [];
function addNotification(notification) {
    return {
        type: "notifications/add",
        payload: { notification: notification },
    };
}
exports.addNotification = addNotification;
function removeNotification(id) {
    return {
        type: "notifications/remove",
        payload: { id: id },
    };
}
exports.removeNotification = removeNotification;
function notificationsReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case "notifications/add":
            if (action.payload.notification.key) {
                state = state.filter(function (item) { return item.key !== action.payload.notification.key; });
            }
            return __spreadArray(__spreadArray(__spreadArray([], __read(state.filter(function (item) { return item.priority <= action.payload.notification.priority; })), false), [
                action.payload.notification
            ], false), __read(state.filter(function (item) { return item.priority > action.payload.notification.priority; })), false);
        case "notifications/remove":
            return state.filter(function (item) { return item.id !== action.payload.id; });
        default:
            return state;
    }
}
exports.default = notificationsReducer;
//# sourceMappingURL=notifications.js.map